let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("9sJzT"), load("6XCf4"), load("5pvpJ"), load("1qlDN"), load("1yVM6"), load("1zoBu")]).then(() => parcelRequire('4QNfT'));